import React from 'react'

import ChangeSalary from './ChangeSalary'
import { Category } from './enum'
import './index.less'

interface TemplateGenerateProps {
  [key: string]: any
}

const TemplateGenerate: React.FC<TemplateGenerateProps> = (props) => {
  const { category = Category.ChangeSalary } = props
  if (category === Category.ChangeSalary) {
    return <ChangeSalary {...props} />
  }
  return <></>
}

export default TemplateGenerate
